<template>
    <div>
        <vx-card title="PRODUTOS VENDIDOS" class="mb-base overflow-hidden">
            <div slot="no-body" class="mt-4">
                <vs-table 
                    :data="products" 
                    class="table-dark-inverted" 
                    stripe no-data-text="Não há dados" 
                    pagination 
                    :max-items="4"
                    noDataText="Não há dados"
                    >
                    <template slot="thead">
                        <vs-th >PRODUTO</vs-th>
                        <vs-th width="50">QTD</vs-th>
                        <vs-th width="150">(R$) TOTAL</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td>
                                <span>{{ tr.description }}</span>
                                <vs-progress :percent="tr.percent"></vs-progress>
                            </vs-td>

                            <vs-td class="text-center">
                                <span>
                                    <number
                                        ref="quantity"
                                        :to="tr.quantity"
                                        :duration="0.6"
                                        :delay="0.5"
                                        easing="Power1.easeOut"
                                    />
                                </span>
                            </vs-td>

                            <vs-td>
                                <number
                                    ref="totalValue"
                                    :to="tr.total"
                                    :format="(number) => $options.filters.currency(number)"
                                    :duration="0.6"
                                    :delay="0.5"
                                    easing="Power1.easeOut"
                                />
                            </vs-td>

                        </vs-tr>
                    </template>
                </vs-table>
            </div>
        </vx-card>
    </div>
</template>

<script>
    export default {
        props : {
            data : {
                type: Array,
                required : true
            }
        },

        computed : {
            products () {
                let products = [...this.data]
                let totalQuantity = products.reduce((acumulator, current) => acumulator + current.quantity, 0);
                products.forEach(k => {
                    k.percent = (k.quantity * 100) / totalQuantity
                });

                return products.sort((a, b) => b.total - a.total)
            }
        },
    }
</script>